import React, { useEffect, useRef } from 'react'
import 'quill/dist/quill.snow.css'
import BlotFormatter from 'quill-blot-formatter'

import { CFieldProps } from '@velocity/shared'
import { useField } from 'formik'
import Quill from 'quill'

// Register BlotFormatter module for image resizing
Quill.register('modules/blotFormatter', BlotFormatter)

interface PlaceholderItem {
  id: string
  label: string
}
export const RenderContent = ({ content }: { content: string }) => {
  let html = ''
  try {
    const delta = JSON.parse(content || '{}')
    const temp = document.createElement('div')
    const quill = new Quill(temp)
    quill.setContents(delta)
    html = temp.children[0].innerHTML // This becomes your HTML
  } catch (error) {
    html = content
  }

  return (
    <div
      style={{ whiteSpace: 'pre-wrap' }}
      dangerouslySetInnerHTML={{ __html: html }}
    ></div>
  )
}
export default function Editor(props: CFieldProps) {
  const [field, , helpers] = useField(props.name)
  const ref = useRef<any>(null)
  const containerRef = useRef<any>(null)
  useEffect(() => {
    const container = containerRef.current
    const editorContainer = container.appendChild(
      container.ownerDocument.createElement('div')
    )
    const placeholderList = props.editorProps?.placeholderList || []
    const toolbar = [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      ['link', 'image'],
      [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ['clean']
    ]

    // Add placeholder dropdown if placeholders exist
    if (placeholderList.length > 0) {
      toolbar.push([{ placeholder: placeholderList.map((p) => p.id) } as any])
    }
    const quill = new Quill(editorContainer, {
      modules: {
        toolbar
      },
      theme: 'snow'
    })
    quill.clipboard.dangerouslyPasteHTML(field.value || '')
    quill.on('text-change', (delta, oldDelta, source) => {
      helpers.setValue(quill.root.innerHTML)
    })

    ref.current = quill

    return () => {
      ref.current = null
      container.innerHTML = ''
    }
  }, [ref, props.editorProps])

  // // Build toolbar modules configuration
  // const toolbarOptions = useMemo(() => {
  //   const baseToolbar = [
  //     [{ header: [1, 2, 3, 4, 5, 6, false] }],
  //     [{ font: [] }],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['blockquote', 'code-block'],
  //     ['link', 'image'],
  //     [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
  //     [{ script: 'sub' }, { script: 'super' }],
  //     [{ indent: '-1' }, { indent: '+1' }],
  //     [{ direction: 'rtl' }],
  //     [{ color: [] }, { background: [] }],
  //     [{ align: [] }],
  //     ['clean']
  //   ]

  //   // Add placeholder dropdown if placeholders exist
  //   if (placeholderList.length > 0) {
  //     baseToolbar.push([
  //       { placeholder: placeholderList.map((p) => p.id) } as any
  //     ])
  //   }

  //   return baseToolbar
  // }, [placeholderList])

  // const { quill } = useQuill({
  //   modules: {
  //     toolbar: toolbarOptions,
  //     blotFormatter: {}
  //   }
  // })
  // const [field, , helpers] = useField(props.name)

  // // Generate CSS for placeholder dropdown labels
  // useEffect(() => {
  //   if (placeholderList.length === 0) return

  //   const styleId = 'quill-placeholder-styles'
  //   let styleTag = document.getElementById(styleId)

  //   if (!styleTag) {
  //     styleTag = document.createElement('style')
  //     styleTag.id = styleId
  //     document.head.appendChild(styleTag)
  //   }

  //   const css = placeholderList
  //     .map(
  //       (p) => `
  //       .ql-picker.ql-placeholder .ql-picker-item[data-value="${p.id}"]::before {
  //         content: "${p.label}";
  //       }
  //     `
  //     )
  //     .join('\n')

  //   styleTag.textContent =
  //     css +
  //     `
  //       .ql-picker.ql-placeholder {
  //         width: 130px;
  //       }
  //       .ql-picker.ql-placeholder > span.ql-picker-label::before {
  //         content: 'Merge Fields';
  //       }
  //       .ql-picker.ql-placeholder .ql-picker-options {
  //         max-height: 200px;
  //         overflow-y: auto;
  //       }
  //     `

  //   return () => {
  //     // Cleanup on unmount
  //     const tag = document.getElementById(styleId)
  //     if (tag) tag.remove()
  //   }
  // }, [placeholderList])

  // // Insert Image(selected by user) to quill
  // const insertToEditor = (url: string) => {
  //   const range = quill?.getSelection()
  //   if (range) quill?.insertEmbed(range.index, 'image', url)
  // }

  // // Upload Image to Image Server such as AWS S3, Cloudinary, Cloud Storage, etc..
  // const saveToServer = async (file: File) => {
  //   const toastId = toast.loading('Uploading image...')
  //   try {
  //     const res = await uploadFile(file, window.location.pathname.split('/')[1])
  //     if (res.status) insertToEditor(res.data?.url)
  //     toast.update(toastId, {
  //       render: 'Image uploaded!',
  //       type: 'success',
  //       isLoading: false
  //     })
  //   } catch (error) {
  //     toast.update(toastId, {
  //       render: 'Failed to upload image',
  //       type: 'error',
  //       isLoading: false
  //     })
  //   } finally {
  //     toast.dismiss(toastId)
  //   }
  // }

  // // Open Dialog to select Image File
  // const selectLocalImage = () => {
  //   const input = document.createElement('input')
  //   input.setAttribute('type', 'file')
  //   input.setAttribute('accept', 'image/*')
  //   input.click()

  //   input.onchange = () => {
  //     const file = input.files?.[0]
  //     if (file) saveToServer(file)
  //   }
  // }

  // React.useEffect(() => {
  //   if (quill) {
  //     quill.clipboard.dangerouslyPasteHTML(field.value || '')
  //     quill.on('text-change', (delta, oldDelta, source) => {
  //       helpers.setValue(quill.root.innerHTML)
  //     })
  //     ;(quill.getModule('toolbar') as any).addHandler('image', selectLocalImage)
  //   }
  //   // eslint-disable-next-line
  // }, [quill])

  // // Set up placeholder dropdown click handlers
  // useEffect(() => {
  //   if (!quill || placeholderList.length === 0) return

  //   const toolbar = quill.getModule('toolbar') as any
  //   const toolbarElement = toolbar?.container as HTMLElement
  //   if (!toolbarElement) return

  //   const pickerItems = toolbarElement.querySelectorAll(
  //     '.ql-placeholder .ql-picker-item'
  //   )

  //   const handleClick = (e: Event) => {
  //     const target = e.target as HTMLElement
  //     const value = target.getAttribute('data-value')
  //     if (!value) return

  //     // Focus the editor and get selection
  //     quill.focus()
  //     const range = quill.getSelection(true)
  //     const placeholderText = `{{${value}}}`
  //     quill.insertText(range.index, placeholderText)
  //     quill.setSelection(range.index + placeholderText.length)

  //     // Reset the dropdown to show "Merge Fields" again
  //     const pickerLabel = toolbarElement.querySelector(
  //       '.ql-placeholder .ql-picker-label'
  //     )
  //     if (pickerLabel) {
  //       pickerLabel.setAttribute('data-value', '')
  //     }
  //   }

  //   pickerItems.forEach((item) => {
  //     item.addEventListener('click', handleClick)
  //   })

  //   return () => {
  //     pickerItems.forEach((item) => {
  //       item.removeEventListener('click', handleClick)
  //     })
  //   }
  // }, [quill, placeholderList])

  return (
    <div style={{ minHeight: 200, backgroundColor: 'white' }}>
      <div ref={containerRef} />
    </div>
  )
}
